import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { ToastService } from '../components/ui/toast/toast.services';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {

      // Webhook ausschließen
      if(req.url.includes('/webhook')) return throwError(error);

      //Fehlermeldung auf dem SendError Backend holen
      // Backend gibt {status, message, error } retour

      const message = error.error?.message ?? error.error?.error ?? 'Ein Fehler ist aufgetreten';

      switch (error.status) {
        case 401:
          toast.error('Nicht autorisiert - bitte neu einloggen');
          break;
          case 403:
            toast.error('Keine Berechtigung für die Aktion');
            break;
            case 404:
              toast.error(`${message}`);
              break;
        case 500:
          toast.error(`Serverfehler: ${message}`);
          break;
        default:
          toast.error(message);
      }
      return throwError(() => error);
    })
  )
};
